<template>
  <div class="marketingProjectContent">
    <div
      style="
        width: 100%;
        height: 40px;
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-around;
        align-items: center;
      "
    >
      <el-button
        style="margin-right: 150px"
        @click="createdProject"
        type="primary"
        size="mini"
        >基本信息设置</el-button>
      <el-button size="mini" type="primary" @click="back()">返回</el-button>

    </div>

    <el-dialog
      destroy-on-close
      title="创建项目"
      :visible.sync="dialogVisible"
      width="500px"
      style="border-radius: 25px"
      center
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="公司名称" prop="projectName">
          <el-input
            style="width: 290px"
            v-model="ruleForm.projectName"
          ></el-input>
        </el-form-item>
        <el-form-item label="项目简介" prop="content">
          <el-input
            style="width: 290px"
            type="textarea"
            v-model="ruleForm.content"
          ></el-input>
        </el-form-item>
        <el-form-item label="项目引入" prop="subjectId">
          <el-select
            style="width: 290px"
            v-model="ruleForm.subjectId"
            placeholder="请选择资源"
          >
            <el-option
              v-for="item in subjectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="upload_custom" label="上传图片" prop="cover">
          <el-upload
            :file-list="flieList"
            list-type="picture-card"
            ref="addUpload"
            :action="materialForm.url"
            :headers="headers"
            :on-success="handleAvatarSuccess"
          >
            <i class="el-input__icon el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <div style="text-align: center !important">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSave('ruleForm')"
            >确 定</el-button
          >
        </div>
      </el-form>
    </el-dialog>

    <div class="new_sidebar">
      <div class="tree">
        <div class="new_sidebar_head">
          目录
          <span class="tagbar_icon" @click="addTreeItem(0)">
            <i class="el-icon-plus"></i>
          </span>
        </div>
        <el-tree
          :data="treeData"
          node-key="id"
          :style="{ height }"
          :props="defaultProps"
          @node-click="handleNodeClick"
          ref="tree"
          :highlight-current="true"
          :default-expanded-keys="[defaultExpansion]"
          :draggable="openDraggable"
        >
          <!--      @node-drop="handleDrop"-->
          <!--      :allow-drop="allowDrop"-->
          <div
            class="custom-tree-node"
            slot-scope="{ node, data }"
            @mouseleave.passive="treemouseLeave()"
            @dblclick="edit(data)"
            @mouseover.passive="treeMouseOver($event, data)"
          >
            <span
              class="custom-tree-node-label"
              v-if="data.id && data.status != 1"
              :title="data.catalogName"
              >{{ data.catalogName }}</span
            >

            <el-input
              class="nodeInput"
              v-if="data.status == 1"
              style="width: 90%; margin-right: 20px"
              v-model="data.catalogName"
              size="small"
              placeholder="添加目录"
              :ref="'edit' + data.id"
              @blur="blurEdit(data)"
              @keyup.enter.native="enterBlur($event, data)"
              maxlength="100"
            ></el-input>

            <span v-if="iconIsShow == data.id">
              <el-popover
                popper-class="zl_sidebar_popper1"
                placement="bottom"
                width="118"
                trigger="click"
              >
                <div class="zl_sidebar_popper_btn" style="user-select: none">
                  <p class="popper_p" @click="addTreeItem(1, data)">
                    <!--                                v-if=" data.resourceBase && !data.resourceBase.length && (data.level === 1 || data.level === 2) && (data.isAddChild === 1)"-->

                    <!-- <img src="../../../static/images/newCourseImages/tianjia@2x.png" alt="添加目录" /> -->
                    <i class="el-icon-circle-plus-outline"></i>
                    <span>子目录</span>
                  </p>
                  <!--              <p-->
                  <!--                class="popper_p"-->
                  <!--                @click="addPage(data)"-->
                  <!--              >-->
                  <!--                &lt;!&ndash;                v-if="data.catalogParentId && data.children &&  !data.children.length && (data.isAddChild === 1)"&ndash;&gt;-->

                  <!--                &lt;!&ndash; <img src="../../../static/images/newCourseImages/tianjia@2x.png" alt="添加页面" /> &ndash;&gt;-->
                  <!--                <i class="el-icon-circle-plus-outline"></i>-->
                  <!--                <span>{{newName}}</span>-->
                  <!--              </p>-->
                  <p class="popper_p" @click="edit(data)">
                    <!-- <img src="../../../static/images/newCourseImages/zh@2x.png" alt="编辑节点" /> -->
                    <i class="el-icon-edit-outline"></i>
                    <span>编辑</span>
                  </p>
                  <p class="popper_p" @click="remove(node, data)">
                    <!-- <img src="../../../static/images/newCourseImages/sc@2x(1).png" alt="删除节点" /> -->
                    <i class="el-icon-delete"></i>
                    <span>删除</span>
                  </p>
                </div>

                <span
                  @click.stop="openSelectType"
                  slot="reference"
                  v-if="data.id"
                  class="el-icon-more catalogedtordel"
                  :class="{
                    'tree-node-block':
                      iconIsShow == data.id && data.status != 1,
                  }"
                ></span>
              </el-popover>
            </span>
          </div>
        </el-tree>
      </div>
      <div class="table">
        <div style="display: flex; justify-content: flex-end; margin: 10px">
          <el-button type="primary" size="mini">云资料引入</el-button>
          <el-drawer
            :visible.sync="isAddMaterial"
            direction="rtl"
            size="80%"
            destroy-on-close
            :with-header="false"
          >
            <!--            <addMaterial @closeAddMaterial="closeAddMaterial" :subjectId="editCourseInfoForm.subject"></addMaterial>-->
          </el-drawer>

          <el-button
            @click="uploadMaterialDrawer"
            type="primary"
            size="mini"
            style="margin-left: 16px"
          >
            本地资料上传
          </el-button>
          <el-drawer
            :visible.sync="isUploadMaterial"
            direction="rtl"
            size="80%"
            destroy-on-close0
            :with-header="false"
          >
            <uploadMaterial
              ref="uploadMaterial"
              :uploadUrl="uploadUrl"
              :categoryId="categoryId"
              :projectId="projectId"
              :subjectId="subjectId"
              :isUploadMaterial="isUploadMaterial"
              @uploadMaterial="uploadMaterial"
              @uploadMaterialClick="uploadMaterialClick"
            ></uploadMaterial>
          </el-drawer>
        </div>
        <el-table :data="documentObj" style="width: 100%">
          <el-table-column label="序号" width="60">
            <template slot-scope="scope">
              {{ scope.$index }}
            </template>
          </el-table-column>
          <el-table-column prop="resourceName" label="资料名称">
          </el-table-column>
          <el-table-column prop="date" label="上传时间"> </el-table-column>
          <el-table-column label="操作" width="60">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="deleteRow(scope.$index, documentObj)"
                type="text"
                size="small"
              >
                移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import newRealyObjectHeader from "@/views/newRealTask/components/newRealyObjectHeader";
// import * as api from "../../../api/courseApi";
import bus from "../../../bus/bus.js";
import * as api1 from "../../../api/courseApi";
import * as api from "../../../api/marketingProjectManagement";
import uploadMaterial from "../../../components/views/course/uploadMaterial";
// import addMaterial from  './addMaterial'

/**
 *        目录树，可修改,新增,拖拽,删除
 *              -- Author by jxl. on 2022.5.12
 */
export default {
  // name: "new_sidebar",
  props: {
    courseId: {
      type: [String, Number],
      default: 0,
    },
    subjectId: {
      type: [String, Number],
      default: 0,
    },
    newName: {
      type: String,
      default: "页面",
    },
  },
  data() {
    return {
      uploadUrl: "/realTaskUpload/uploadFile",
      ruleForm: {
        projectName: "",
        content: "",
        subjectId: "",
        cover: "",
      },
      rules: {
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入项目简介", trigger: "blur" },
        ],
        subjectId: [
          { required: true, message: "请选择资源", trigger: "change" },
        ],
        cover: [{ required: true, message: "请上传图片", trigger: "change" }],
      },
      professionalId: sessionStorage.getItem("professional"),
      professional: sessionStorage.getItem("professional"),
      dialogVisible: false,
      projectName: "",
      subjectList: [],
      content: "",
      materialForm: {
        url: `${process.env.UPLOAD_NAME}/fileUpload/uploadFile`,
        data: {
          savepath: "cjdd/resourse/",
        },
        fileName: "",
        id: "",
      },
      flieList: [],
      catalogParentId: -1,
      projectId: -1,
      categoryId: -1,
      isAddMaterial: false, //添加
      isUploadMaterial: false, //上传
      drawer: false,
      imgUrl: "../../../../static/images/hed0.png",
      tableData: [
        {
          date: "2016-05-03",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333,
        },
      ],
      menuType: this.$route.query.menuType, //课程类型 ，2单项 3综合
      treeData: [],
      defaultExpansion: 0, //默认展开的目录
      activeOne: {},
      height: window.innerHeight / 1.4 + "px",

      defaultProps: {
        //目录配置
        children: "child",
        label: "catalogName",
      },
      popover_visible: false,
      iconIsShow: -1,
      oldCatalogName: "",
      openDraggable: true,
      cover: "",
      documentObj: [],
    };
  },
  created() {
    this.init();
    this.getSubjectList();
    this.getCourseCatalog();
    // bus.$on("businit", this.getCourseCatalog);
  },
  computed: {
    headers() {
      return {
        Authorization: "bearer " + localStorage.getItem("Authorization"),
      };
    },
  },
  beforeDestroy() {
    bus.$off("businit");
    // sessionStorage.removeItem("new_sidebar_default");
  },
  methods: {
    init() {
      let params = {
        id: this.categoryId,
      };
      api.projectResourceQueryList(params).then((res) => {
        if (res.code == 0) {
          this.documentObj = res.data;
          
        }
      });
    },

    getSubjectList() {
      //获取科目列表
      api1
        .getSubjectList()
        .then((rs) => {
          if (rs.code == 0) {
            rs.data.forEach((item) => {
              //professionId==3   是智能估值
              if (item.professionId == this.professional) {
                this.subjectList.push(item);
              }
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    createdProject() {
      this.ruleForm.cover = this.$route.query.cover;
      this.flieList = [{ name: "", url: this.ruleForm.cover }];
      this.ruleForm.projectName = this.$route.query.projectName;
      this.ruleForm.content = this.$route.query.content;
      this.ruleForm.subjectId = Number(this.$route.query.id);

      this.dialogVisible = true;
    },
    uploadMaterialClick() {
      this.isUploadMaterial = false;
    },
    closeAddMaterial() {
      this.isAddMaterial = false;
      this.handleNodeClick(this.selectTreeData);
    },
    uploadMaterialDrawer() {
      //上传素材
      this.isUploadMaterial = true;
      if (this.$refs.uploadMaterial) {
        this.$refs.uploadMaterial.init(this.courseForm);
      }
    },
    uploadMaterial(id) {
      // 上传素材保存
      let that = this;
      let obj = {
        catalogId: that.categoryId,
        courseId: that.courseId,
        list: [
          {
            catalogId: that.categoryId,
            // courseId: that.courseId,
            resourceId: id,
            type: 1,
          },
        ],
      };
      this.init();
    },
    handleCommand(command) {
      //退出
      if (command == "d") {
        this.$logOut();
      } else if (command == "a") {
        this.$router.push("/educa");
      } else if (command == "b") {
        this.$router.push("/settings");
      } else if (command == "s") {
        this.$router.push("/dataStatistics");
      }
    },
    deleteRow(a, b) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: b[a].id,
          };
          api.projectResourceDelete(params).then((res) => {
            if (res.code == 0) {
              this.init();
              // this.answerList = res.data
            }
          });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    uploadFiles(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    //查询树的list
    getCourseCatalog() {
      this.projectId = this.$route.query.id;
      this.params = {
        projectId: this.$route.query.id,
      };
      api
        .projectCatalogList(this.params)
        .then((res) => {
          if (res.code == 0) {
            if (res.data && res.data.length) {
              this.treeData = res.data;
            } else {
              this.treeData = [];
            }
          } else {
            this.$messageError(res.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 编辑tree input 失去焦点
    blurEdit(data) {
      if (data.catalogName == "" || this.oldCatalogName == data.catalogName) {
        this.$set(data, "status", 0);
        // 空的不保存不提示没反应
        if (data.catalogName == "" && this.oldCatalogName != "") {
          data.catalogName = this.oldCatalogName;
        }
        this.resertTree(this.treeData);
        return;
      }
      this.defaultExpansion = 0;
      if (data.id) {
        api
          .editCatalogSave(data.id, data.catalogName)
          .then((res) => {
            if (res.code == "0") {
              this.$message.success("修改成功");
              this.defaultExpansion = data.id;
              this.getCourseCatalog();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        api
          .projectCatalogsave(data, { method: "post" })
          .then((res) => {
            bus.$emit("businit");
            if (res.code == "0") {
              this.$message.success("添加成功");
              this.defaultExpansion = res.data.id;
              this.activeOne = res.data;
              sessionStorage.setItem(
                "new_sidebar_default",
                JSON.stringify({ id: res.data.id })
              );
              this.getCourseCatalog();
              this.$set(data, "status", 0);
              // 如果有type,是添加素材目录，并添加素材
              if (data.type == 6) {
                this.addImageText(res.data, data);
              } else if (data.type) {
                this.addResourse(res.data, data);
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    defualtOne(data) {
      this.defaultExpansion = data.id;
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(this.defaultExpansion);
        let newData = this.$refs.tree.getCurrentNode(this.defaultExpansion);
        this.handleNodeClick(newData);
      });
    },
    handleNodeClick(data) {
      this.categoryId = data.id;
      this.init();

      if (data === null) {
        this.$emit("clearCatalogName", "");
        return;
      }
      if (!data.catalogName) {
        this.$emit("clearCatalogName", "");
        return;
      }
      this.activeOne = data;
      this.$emit("clearCatalogName", data.catalogName);
      let defualtopt = sessionStorage.getItem("new_sidebar_default");
      if (defualtopt) {
        let opt = JSON.parse(defualtopt);
        if (opt.id && opt.id === data.id && opt.tagIndex > 0) {
          sessionStorage.setItem(
            "new_sidebar_default",
            JSON.stringify({ id: data.id, tagIndex: opt.tagIndex })
          );
        } else {
          sessionStorage.setItem(
            "new_sidebar_default",
            JSON.stringify({ id: data.id })
          );
        }
      } else {
        sessionStorage.setItem(
          "new_sidebar_default",
          JSON.stringify({ id: data.id })
        );
      }

      //点击课程目录
      this.$emit("handleTreeNodeClick", data);
    },
    // *  type 1素材，2作业，3习题，5测验，6图文，7图片，8文档, 9音频，10视频
    // 添加一级目录（章节）
    addTreeItem(a, data) {
      if (a == 0) {
        this.resertTree(this.treeData);
        var obj = {
          status: 1,
          id: "",
          catalogName: "",
          catalogParentId: 0,
          projectId: this.$route.query.id,
        };
        this.treeData.push({ ...obj });
        this.edit({ ...obj });
      } else {
        var obj = {
          status: 1,
          id: "",
          catalogName: "",
          catalogParentId: data.id,
          projectId: this.$route.query.id,
        };
        this.treeData.push({ ...obj });
        this.edit({ ...obj });
      }
    },
    // 编辑节点
    edit(data) {
      // this.openDraggable = false;
      this.$set(data, "status", 1); //data.status=1
      if (data.catalogName) {
        this.oldCatalogName = data.catalogName;
      }
      this.$nextTick(() => {
        let that = this;
        let timer = setTimeout(() => {
          if (that.$refs["edit" + data.id])
            that.$refs["edit" + data.id].$refs.input.focus();
          clearTimeout(timer);
        }, 30);
      });
    },
    openSelectType() {
      this.popover_visible = true;
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 0) {
        this.ruleForm.cover = res.data.newAttaUrl;
      } else {
        let fileId = file.uid;
        this.showUploadFileList.forEach((item) => {
          if (item.uid == fileId) {
            item.state = "上传失败";
          }
        });
        this.$message.error("格式不支持上传");
      }
    },
    //保存
    handleSave(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.cover == "") {
            this.$message({
              message: "请上传图片",
              type: "warning",
            });
            return;
          }
          let params = {
            id: this.$route.query.id,
            projectName: this.ruleForm.projectName,
            cover: this.ruleForm.cover,
            content: this.ruleForm.content,
            subjectId: this.ruleForm.subjectId,
            professionalId: this.professional,
          };
          // if (
          //   this.ruleForm.projectName != "" &&
          //   this.ruleForm.cover != "" &&
          //   this.ruleForm.content != "" &&
          //   this.ruleForm.subjectId != ""
          // ) {
          api.saveOrUpdate(params).then((res) => {
            if (res.code == 0) {
              this.dialogVisible = false;
              // this.init();
              this.$message({
                message: "修改成功",
                type: "success",
              });
            }
          });
          // } else {
          //   this.$message({
          //     message: "空的，不能保存",
          //     type: "warning",
          //   });
          // }
        } else {
          return false;
        }
      });
    },
    // allowDrop(draggingNode, dropNode, type){
    //   // 不能拖拽有子级的目录
    //   if (draggingNode.data.children && draggingNode.data.children.length){
    //     // console.log('--allowDrop--', type, draggingNode.data,dropNode.data )
    //     if (type== 'prev' || type== 'next'){
    //       if (draggingNode.data.catalogParentId === dropNode.data.catalogParentId){
    //         return type
    //       }
    //     }
    //   }else if (type === 'inner'){
    //     if (dropNode.data.resourceBase && dropNode.data.resourceBase.length ){
    //       // 不能给添加了素材的目录插入子级
    //       return false;
    //     }else if (dropNode.level == 3){
    //       // 不能给第三级目录插入子级
    //       return false;
    //     }else{
    //       return type
    //     }
    //   }else{
    //     if (draggingNode.data.resourceBase && draggingNode.data.resourceBase.length && dropNode.level == 1) {
    //       return false;
    //     }else{
    //       return type
    //     }
    //   }
    // },
    // 目录节点拖拽完成
    // handleDrop(before, after, inner) {
    //   // if (before.data.catalogParentId != after.data.catalogParentId) return;
    //   let level = 0;
    //   if (inner == "before") {
    //     level = 0;
    //   } else if (inner == "inner") {
    //     level = 1;
    //   } else if (inner == "after") {
    //     level = 2;
    //   }
    //   // 拖拽成功完成时触发的事件
    //   let obj = {
    //     catalogId: before.data.id,
    //     courseId: this.courseId,
    //     professionId: this.professionId,
    //     level: level,
    //     targetId: after.data.id,
    //     // catalogSort:0
    //   };
    //   api.handleDrop(obj)
    //     .then(() => {
    //       this.getCourseCatalog();
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },

    //  保存图文内容
    // addImageText(catalog, data) {
    //   let params = {
    //     subjectId: this.subjectId,
    //     name: data.catalogName,
    //     imageText: data.resourceId,
    //   };
    //   api.postAddImageText(params).then((res) => {
    //     if (res.code == 0) {
    //       let param = {
    //         courseId: data.courseId,
    //         type: data.type,
    //         resourceId: res.data.id,
    //       };
    //       this.addResourse(catalog, param);
    //     }
    //   });
    // },

    // 给目录绑定资源
    // addResourse(catalog, data) {
    //   let resourse = {
    //     catalogId: catalog.id,
    //     courseId: data.courseId,
    //     list: [
    //       {
    //         catalogId: catalog.id,
    //         courseId: data.courseId,
    //         resourceId: data.resourceId,
    //         type: data.type,
    //       },
    //     ],
    //   };
    //   api.postAddMaterialOne(resourse)
    //     .then((res) => {
    //       if (res.code == "0") {
    //         this.$emit("handleTreeNodeClick", catalog);
    //         this.$message.success("保存成功");
    //       } else {
    //         this.$message.warning(res.msg);
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },

    addPage(data) {
      this.$emit("handleTreeNodeClick", data);
      setTimeout(() => {
        sessionStorage.setItem(
          "new_sidebar_default",
          JSON.stringify({ id: data.id })
        );
        this.$emit("handleTreeNodeClick", data, "add");
        // sessionStorage.setItem(
        //   "new_sidebar_default",
        //   JSON.stringify({ id: data.id })
        // );
        this.popover_visible = false;
        this.iconIsShow = -1;
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(data.id);
        });
      }, 200);
    },
    enterBlur(event, data) {
      if (data.catalogName == "") {
        this.$message.warning("目录名称不得为空");
      }
      event.target.blur(data);
      // this.getCourseCatalog();
    },
    //删除节点
    remove(node, data, resourse) {
      if (data.children && data.children.length !== 0) {
        this.$message.warning("此节点有子节点不可删除");
      } else {
        this.$confirm("是否删除该节点?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            if (data.resourceBase && data.resourceBase.length > 0) {
              // 如果目录下有资源，则先删除资源，再删除目录
              if (resourse) {
                this.removeResourse(data, resourse);
              } else {
                this.removeResourse(data, data.resourceBase[0]);
              }
            } else {
              // 目录下没有资源，删除目录
              this.removeCatalog(data);
            }
            if (sessionStorage.getItem("new_sidebar_default")) {
              if (
                data.id ==
                JSON.parse(sessionStorage.getItem("new_sidebar_default")).id
              ) {
                sessionStorage.removeItem("new_sidebar_default");
              }
            }
          })
          .catch(() => {});
      }
    },
    // 删除目录下的素材
    // removeResourse(data, resourse) {
    //   let daleteResourse = {
    //     catalogId: data.id,
    //     courseId: this.courseId,
    //     list: [resourse.id],
    //   };
    //   api
    //     .batchDeleteSource(daleteResourse)
    //     .then((res) => {
    //       if (res.code == 0) {
    //         this.$message.success("删除素材成功");
    //         this.$emit("clearCatalogName", "");
    //         this.removeCatalog(data);
    //       } else if (res.code == "1") {
    //         this.$message.warning(res.msg);
    //       } else {
    //         this.$message.error("系统错误");
    //       }
    //     })
    //     .catch((error) => {
    //       this.$message.error(error);
    //     });
    // },

    // 删除目录
    removeCatalog(data) {
      let params = {
        id: data.id,
      };
      api
        .projectCatalogdel(params)
        .then((res) => {
          if (res.code == "0") {
            this.defaultExpansion = data.catalogParentId;
            this.getCourseCatalog();
            this.$emit("setStatus", 0);
            this.$message.success("删除目录成功");
            this.$emit("clearCatalogName", "");
          } else if (res.code == "1") {
            this.$message.warning(res.msg);
          } else {
            this.$message.error("系统错误");
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    // 手动刷新tree数据。空id的都清除掉
    resertTree(arr) {
      [].forEach.call(arr, (item, index) => {
        if (!item.id) arr.splice(index, 1);
        if (item.children && item.children.length) {
          this.resertTree(item.children);
        }
      });
      this.openDraggable = true;
    },

    // 鼠标移入移出事件
    treeMouseOver(e, data) {
      if (data.isResoures) return;
      this.iconIsShow = data.id;
    },

    treemouseLeave() {
      if (!this.popover_visible) {
        this.iconIsShow = -1;
      }
      this.popover_visible = false;
    },
    back() {
      // this.$router.go(-1);
      this.$router.push({
        path: '/auditNewRealTask/marketingProjectManagement',
        query: {
          value:2,
        }

      })
    },
  },
  components: {
    newRealyObjectHeader,
    uploadMaterial,
  },
};
</script>
<style scoped lang="scss">
.marketingProjectContent {
  background: #f5f5f7;
  height: 100%;
  width: 100%;
  .imgBox {
    float: left;
    width: 38px;
    height: 38px;
    text-align: center;
    line-height: 38px;
    border: 1px solid #3e3e3e;
    border-radius: 50%;

    img {
      width: 38px;
      height: 38px;
    }
  }

  .new_sidebar {
    height: 95%;
    width: 100%;
    display: flex;
    justify-content: center;

    .new_sidebar_head {
      padding: 15px 10px;
      font-weight: 600;
      font-size: 15px;
      border-bottom: 1px solid #d2d2d7;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;

      i {
        border: 1px solid black;
      }
    }

    .tree {
      background: white;
      width: 240px;
      margin: 0px 10px 70px 10px;
      border: 1px solid rgb(244, 244, 245);
      box-shadow: 0 2px 12px 0 #c9cdcf;
    }

    .table {
      background: white;
      width: 1024px;
      margin: 0px 10px 70px 10px;
      padding: 10px;
      border: 1px solid rgb(244, 244, 245);
      box-shadow: 0 2px 12px 0 #c9cdcf;
    }

    /deep/ .el-tree {
      background: #ffffff;
      margin: 0 10px;
    }

    /deep/ .el-tree-node__content {
      height: 32px;
      border-radius: 5px;

      &:hover {
        background: rgba(24, 144, 255, 0.09);

        .custom-tree-node {
          color: rgba(24, 144, 255, 1) !important;
        }
      }

      .custom-tree-node {
        padding-right: 8px;
        width: 100%;
        color: #42414d;
        height: 32px;
        line-height: 32px;
        display: flex;
        justify-content: space-between;
        /*font-size: 15px;*/
        position: relative;

        .custom-tree-node-label {
          display: inline-block;
          width: 145px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
      }

      .catalogedtordel {
        display: inline-block;
        margin-right: 4px;
        transform: rotate(90deg);
      }

      .el-icon-circle-plus-outline {
        margin: 0 3px;
        display: none;
        line-height: 32px;
        font-size: 15px;
      }

      .selectType {
        width: 120px;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 5000;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/auditNewRealTask/components/marketingProjectContent.vue